$(".announcement-bar-static .top-bar__slider").slick({
  dots: false,
  infinite: true,
  speed: 500,
  autoplay: true,
  autoplaySpeed: 3000,
  vertical: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  adaptiveHeight: false,
  centerMode: false,
  arrows: false
});


$("[data-oke-reviews-product-listing-rating]").click(function(e) {
  e.preventDefault();
  const reviewsWidget = $("[data-oke-reviews-widget-holder]");
  
  if (reviewsWidget.length > 0) {
    const headerOffset = 100;
    const scrollPosition = reviewsWidget.offset().top - headerOffset;
    $('html, body').animate({
      scrollTop: scrollPosition
    }, 800);
  }
});

function openFiltersModal(filtersContainer) {
  if (!filtersContainer) return;
  
  filtersContainer.classList.add('is-visible');
  document.body.style.overflow = 'hidden';
}

function closeFiltersModal(filtersContainer) {
  if (!filtersContainer) return;
  
  filtersContainer.classList.remove('is-visible');
  filtersContainer.classList.remove('collection__filters--visible');
  
  document.dispatchEvent(new CustomEvent('theme:scroll:unlock', { bubbles: true }));
  
  document.body.style.overflow = '';
  
  document.documentElement.removeAttribute('data-scroll-locked');
}

document.addEventListener('click', function(e) {
  if (e.target.matches('[data-filters-toggle]') || e.target.closest('[data-filters-toggle]')) {
    const filtersContainer = document.querySelector('[data-collection-filters]');
    openFiltersModal(filtersContainer);
  }

  if (e.target.matches('[data-close-filters]') || e.target.closest('[data-close-filters]')) {
    const filtersContainer = document.querySelector('[data-collection-filters]');
    closeFiltersModal(filtersContainer);
  }

  if (e.target.matches('[data-collection-filters]')) {
    const filtersContainer = e.target;
    closeFiltersModal(filtersContainer);
  }
});

document.addEventListener('DOMContentLoaded', () => {
  document.addEventListener('click', async (event) => {
    if (event.target.matches('.linked-dropdown .linked-product button.linked-swatch') || 
        event.target.closest('.linked-dropdown .linked-product button.linked-swatch')) {
      
      event.preventDefault();
      event.stopPropagation();
      
      const link = event.target.matches('button.linked-swatch') ? event.target : event.target.closest('button.linked-swatch');
      const handle = link.dataset.handle;
      const productCard = link.closest('.product-grid-item');

      console.log('Linked swatch clicked, handle:', handle);

      if (!handle) {
        console.error('No handle found on clicked swatch');
        return;
      }

      if (!productCard) {
        console.error('Product card not found');
        return;
      }

      try {
        // Add loading state
        productCard.style.opacity = '0.6';
        productCard.style.pointerEvents = 'none';
        
        const response = await fetch(`/products/${handle}?view=product-card`);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        
        const htmlText = await response.text();
        const temp = document.createElement('div');
        temp.innerHTML = htmlText;
        const newCard = temp.querySelector('.product-grid-item');
        
        if (!newCard) {
          throw new Error('New product card not found in response');
        }
        
        // Replace content
        productCard.innerHTML = newCard.innerHTML;
        productCard.style.opacity = '1';
        productCard.style.pointerEvents = '';
        
        console.log('Product card updated successfully');

      } catch (err) {
        console.error('Error loading product card:', err);
        // Reset states on error
        productCard.style.opacity = '1';
        productCard.style.pointerEvents = '';
      }
    }
  });
});

// Linked products show more functionality - using event delegation
document.addEventListener('DOMContentLoaded', function() {
  document.addEventListener('click', function(event) {
    if (event.target.matches('[data-toggle-more]') || event.target.closest('[data-toggle-more]')) {
      event.preventDefault();
      event.stopPropagation();
      
      const button = event.target.matches('[data-toggle-more]') ? event.target : event.target.closest('[data-toggle-more]');
      const dropdown = button.closest('.linked-dropdown');
      
      if (dropdown) {
        dropdown.classList.toggle('expanded');
        console.log('Toggle more clicked, expanded:', dropdown.classList.contains('expanded'));
      }
    }
  });
});


document.dispatchEvent(new  CustomEvent("swym:collections-loaded"));
